var _circle, _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTechnics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 111,
    viewBox: "0 0 80 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 40.0595,
    cy: 55.5004,
    r: 31.8925,
    fill: "url(#paint0_linear_96_1450)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16699 55.5004C8.16699 73.1142 22.4457 87.3929 40.0595 87.3929V48.2119H9.00364C8.4564 50.5528 8.16699 52.9928 8.16699 55.5004Z",
    fill: "url(#paint1_linear_96_1450)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.9521 55.5004C71.9521 73.1142 57.6734 87.3929 40.0597 87.3929V48.2119H71.1155C71.6627 50.5528 71.9521 52.9928 71.9521 55.5004Z",
    fill: "url(#paint2_linear_96_1450)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0601 90.5601C20.6969 90.5601 5 74.8631 5 55.5C5 36.1369 20.6969 20.4399 40.0601 20.4399C59.4233 20.4399 75.1202 36.1369 75.1202 55.5C75.1202 74.8631 59.4232 90.5601 40.0601 90.5601ZM40.0601 23.5953C22.4396 23.5953 8.15541 37.8795 8.15541 55.5C8.15541 73.1204 22.4396 87.4047 40.0601 87.4047C57.6806 87.4047 71.9648 73.1205 71.9648 55.5C71.9648 37.8795 57.6806 23.5953 40.0601 23.5953Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.8585 48.176C72.6749 48.176 73.3366 48.8377 73.3366 49.6541V50.1388C73.3366 50.9551 72.6749 51.6169 71.8585 51.6169L8.26159 51.6169C7.44526 51.6169 6.78349 50.9551 6.78349 50.1388V49.6541C6.78349 48.8377 7.44526 48.176 8.26159 48.176L71.8585 48.176Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7806 87.6866C41.7806 88.5029 41.1188 89.1647 40.3025 89.1647H39.8177C39.0014 89.1647 38.3396 88.5029 38.3396 87.6866L38.3396 51.4034C38.3396 50.5871 39.0014 49.9253 39.8177 49.9253H40.3025C41.1188 49.9253 41.7806 50.5871 41.7806 51.4034L41.7806 87.6866Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_96_1450",
    x1: 56.2565,
    y1: 28.3726,
    x2: 27.4981,
    y2: 83.9848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0066FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_96_1450",
    x1: 20.9044,
    y1: 83.9731,
    x2: 44.6986,
    y2: 54.0414,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00CD83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DBFF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_96_1450",
    x1: 41.6366,
    y1: 87.3929,
    x2: 65.6773,
    y2: 46.9076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9900"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechnics);
export default __webpack_public_path__ + "static/media/technics.181db821d6a6eb5220e7351a491de1cc.svg";
export { ForwardRef as ReactComponent };